import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";
import { t } from "@/lib/i18n";
import { formatApiErrorDetail } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", name: "", restaurant_name: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register({ ...form, role: "restaurant_owner" });
      toast.success("Account creato!");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div className="flex items-center justify-center p-8 order-2 lg:order-1">
        <form onSubmit={onSubmit} className="w-full max-w-md space-y-5 fade-up" data-testid="register-form">
          <div>
            <h1 className="font-display text-4xl font-black tracking-tighter">{t.auth.register_title}</h1>
            <p className="mt-2 text-muted-foreground">{t.auth.register_sub}</p>
          </div>
          <div className="space-y-2">
            <Label>{t.auth.name}</Label>
            <Input value={form.name} onChange={set("name")} required data-testid="register-name-input" />
          </div>
          <div className="space-y-2">
            <Label>{t.auth.restaurant_name}</Label>
            <Input value={form.restaurant_name} onChange={set("restaurant_name")} required data-testid="register-restaurant-input" />
          </div>
          <div className="space-y-2">
            <Label>{t.auth.email}</Label>
            <Input type="email" value={form.email} onChange={set("email")} required data-testid="register-email-input" />
          </div>
          <div className="space-y-2">
            <Label>{t.auth.password}</Label>
            <Input type="password" value={form.password} onChange={set("password")} required data-testid="register-password-input" />
          </div>
          <Button type="submit" className="w-full pill-btn h-11 bg-primary text-primary-foreground hover:bg-[hsl(var(--accent))]" disabled={loading} data-testid="register-submit-btn">
            {loading ? "..." : t.auth.submit_register}
          </Button>
          <div className="text-sm text-muted-foreground text-center">
            {t.auth.have_account} <Link to="/login" className="text-[hsl(var(--accent))] hover:underline" data-testid="register-goto-login">{t.auth.login_link}</Link>
          </div>
        </form>
      </div>
      <div className="hidden lg:block relative order-1 lg:order-2">
        <img src="https://images.pexels.com/photos/1327393/pexels-photo-1327393.jpeg" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[hsl(var(--accent))]/40" />
        <div className="relative z-10 h-full flex items-end p-12 text-white">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] opacity-80 mb-4">7 giorni di prova</div>
            <h2 className="font-display text-4xl font-black tracking-tighter max-w-md">
              Prova senza carta. Attivalo in un minuto.
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
}
